import * as yup from 'yup';

export const orderTrucksCountSchema = yup.object().shape({
  trucksCount: yup.number().integer().min(1).max(200).required(),
});

export type OrderTrucksCountDto = yup.InferType<typeof orderTrucksCountSchema>;
